/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import MotorQuoteExcess from './MotorQuoteExcess';

export default MotorQuoteExcess;
